import { __awaiter, __generator } from "tslib";
import { OfficeWorkload, } from '@office-start/officehome-types';
import { getUserStorageItem, setUserStorageItem, } from '@office-start/user-storage-service';
import { areThirdPartyAppsEqual } from './areThirdPartyAppsEqual';
export var USED_THIRD_PARTY_APPS_USER_STORAGE_KEY = 'UsedThirdPartyApps';
export function updateUsedThirdPartyAppsUserData(app, componentContext) {
    return __awaiter(this, void 0, void 0, function () {
        var userStorageOptions, usedThirdPartyWorkloads, cachedWorkloadIndex, cachedWorkload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!componentContext)
                        return [2 /*return*/];
                    userStorageOptions = buildUserStorageOptions(componentContext);
                    return [4 /*yield*/, getUsedThirdPartyAppsUserData(userStorageOptions)];
                case 1:
                    usedThirdPartyWorkloads = (_a.sent()) || [];
                    cachedWorkloadIndex = usedThirdPartyWorkloads.findIndex(function (workload) { return workload.Id.toLowerCase() === app.Id.toLowerCase(); });
                    cachedWorkload = cachedWorkloadIndex >= 0
                        ? usedThirdPartyWorkloads[cachedWorkloadIndex]
                        : undefined;
                    if (cachedWorkload) {
                        if (!areThirdPartyAppsEqual(cachedWorkload, app)) {
                            usedThirdPartyWorkloads[cachedWorkloadIndex] = app;
                            setUsedThirdPartyAppsUserData(usedThirdPartyWorkloads, userStorageOptions);
                        }
                    }
                    else {
                        usedThirdPartyWorkloads.push(app);
                        setUsedThirdPartyAppsUserData(usedThirdPartyWorkloads, userStorageOptions);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function buildUserStorageOptions(componentContext) {
    return {
        correlationId: componentContext.correlationId,
        getAccessToken: componentContext.getAccessToken,
        getIdentity: componentContext.getIdentity,
        inMockMode: componentContext.inMockMode,
        jwtAuthEnabled: componentContext.jwtAuthEnabled,
        officeHomeApiRoot: componentContext.officeHomeApiRoot,
        workload: OfficeWorkload.OfficeHomeReact,
    };
}
export function getUsedThirdPartyAppsUserData(userStorageOptions) {
    return getUserStorageItem(USED_THIRD_PARTY_APPS_USER_STORAGE_KEY, userStorageOptions);
}
export function setUsedThirdPartyAppsUserData(userData, userStorageOptions) {
    return setUserStorageItem(USED_THIRD_PARTY_APPS_USER_STORAGE_KEY, userData, userStorageOptions);
}
//# sourceMappingURL=usedThirdPartyAppsUtils.js.map